import { TransactionDirection, TransactionType } from "./Transaction";

export interface StandingInstruction {
  nickname: string,
  cashieringRqstId: string,
  cashieringRqstSecondId: string,
  fundsDirection: TransactionDirection,
  transactionType: TransactionType,
  txnCode?: string;
  to1: string,
  to2: string,
  to3: string,
  statusCd: 'ACTV' | 'INAC' | string,
  masterAccountId: string,
  address: string,
  isThirdParty: boolean,

  isSloaSetup?: boolean;
  processDate?: string;
  incomingAmount?: number;
  outgoingAmount?: number;
  isRecurring: boolean;
  frequencyCode?: string;
  frequencyDescription?: string;
  isPercent?: boolean;
  statusCodeDescription?: string;

  isViewable?: boolean,
  isEditable?: boolean,
  isCancelable?: boolean,
  isReactivatable?: boolean,
  isRequestTransaction?: boolean,
  isBundled?: boolean
  descriptionSuffix?: string;
  isStandingInstruction?: boolean;

  isRequestTrans?: boolean,
  mediaTypeCd: string,
  typeDescription?: string,
  bundledSloaIn?: boolean,
  thirdPartyInd?: boolean,
  faMasterAcct?: string

  abaNumber?: string;
  accountName?: string;
  accountType?: string;
}

export interface StandingAuthDetails {
  nickname: string;
  payeeLines: string[];
  addressLines: string[];
}

export const isStandingInstruction = (transaction: any): transaction is StandingInstruction => {
  return transaction.isThirdParty !== null && transaction.isThirdParty !== undefined;
}
